// filepath: src/firebase/firestore/useIcrList.js
import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch the ICR collection, optionally filtered by pirId.
 * Returns { data, loading, error }.
 */
export function useIcrList(pirId, options = {}) {
    const {limit = undefined} = options;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);

        let url = `${BASE}/api/intelligence-requests?type=ICR`;
        if (pirId) url += `&pirId=${encodeURIComponent(pirId)}`;
        if (typeof limit === 'number' && limit > 0) url += `&limit=${limit}`;

        fetch(url, {headers: authHeaders()})
            .then((r) => r.ok ? r.json() : Promise.reject(new Error(`${r.status}`)))
            .then((list) => { setData(Array.isArray(list) ? list : []); setLoading(false); })
            .catch((err) => { setError(err); setLoading(false); });
    }, [pirId, limit]);

    return {data, loading, error};
}
